import { render, staticRenderFns } from "./SubNavDrawer.vue?vue&type=template&id=a2360dea&scoped=true"
import script from "./SubNavDrawer.vue?vue&type=script&lang=js"
export * from "./SubNavDrawer.vue?vue&type=script&lang=js"
import style0 from "./SubNavDrawer.vue?vue&type=style&index=0&id=a2360dea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2360dea",
  null
  
)

export default component.exports